import React, { Component } from 'react';
import './new-homework.scss';
import { Constants, ImageConstants } from '../../constants/constants';
import { getImageSource } from '../../utility/image-source'
import Dropdown from '../common/dropdown-v2/dropdown';
import HomeworkApi from '../../apis/homework'
import SchoolUserApi from '../../apis/student'
import Loading from '../common/loading/loading'

import PillButton from '../common/pill-button-select/pill-button-select'

import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import CompletionScreen from './completion-screen/completion-screen'

class NewHomeWork extends Component {

    state = {
        boards: [],
        classes: [],
        sectionDropdown: [],
        schoolName: "Coutingwell Acadamy",
        selectedSchoolwork : "STANDARD_CLASSWORK"
    }

    chapterHash = {}
    masterDataHash = {}
    sectionHash = {}

    constructor() {
        super()

        let urlParams = new URLSearchParams(window.location.search);

        this.teacherId = urlParams.get('teacherId')
        this.schoolId = urlParams.get('schoolId')
        let className = urlParams.get('class')
        let board = urlParams.get('board')
        let chapterKey = urlParams.get('chapterKey')
        if (board) board = board.split("_").join(" ")
        if (className) className = className.split("_").join(" ")
        if (chapterKey) chapterKey = chapterKey.split("_").join(" ")
        this.state.selectedClass = className
        this.state.selectedBoard = board
        this.state.selectedChapter = chapterKey

    }

    componentDidMount() {
        this.getHomeworkDetail()
    }

    getHomeworkDetail(payload = {}) {
        payload.schoolId = this.schoolId
        this.setState({ isLoading: true, })
        HomeworkApi.getHomeworkDetailForLink(payload)
            .then(response => {
                this.buildInputData(response)
                this.setState({ isLoading: false, schoolName: response.schoolName })
            }).catch(err => {
                this.setState({ isLoading: false })
            })
    }

    buildInputData(response) {
        this.masterDataHash = {}
        this.sectionHash = {}
        let classDetail = response.classes
        let boardDetail = response.boards
        let masterDataList = response.masterData
        let sectionDetail = response.sections

        let classes = classDetail.map(item => ({ title: item, value: item }))
        let boards = boardDetail.map(item => ({ title: item, value: item }))
        masterDataList.forEach(element => {
            this.masterDataHash[element.class] = element
        });

        sectionDetail.forEach(element => {
            let key = `${element.board}_${element.class}`
            if (this.sectionHash[key]) this.sectionHash[key].push(element)
            else this.sectionHash[key] = [element]
        })

        this.setState({ classes, boards })

        if (this.state.selectedBoard && this.state.selectedClass) {
            this.onSelectClass(this.state.selectedClass)
            if (this.state.selectedChapter) this.onSelectDropdown({ value: this.state.selectedChapter }, "selectedChapter")
        }
    }

    onClickCreate() {

        let payload = {
            board: this.state.selectedBoard,
            class: this.state.selectedClass,
            chapterKey: this.state.selectedChapter,
            concepts: this.state.selectedConcept,
            dueDate: this.startDate ? (new Date(new Date(this.startDate).setHours(23, 59, 59, 999)).toISOString()).slice(0, -1) : '',
            masterDataId: this.state.masterDataId,
            section: this.state.section,
            sectionId: this.state.sectionId,
            teacherId: this.teacherId,
            schoolId: this.schoolId,
            type : this.state.selectedSchoolwork
        }

        let validate = this.validatePayload(payload, true)

        if (!validate) {
            this.setState({ isCreate: true })
            return
        }

        if (this.saving) return

        this.saving = true
        this.setState({ isLoading: true })

        HomeworkApi.createHomeworkForLink(payload).then(response => {
            this.saving = false
            this.setState({ isLoading: false, isCompleted: true, homeworkDetail: response?.data || {} })
            console.log("response", response)
        }).catch(err => {
            this.saving = false
            this.setState({ isLoading: false })
        })
    }

    onSelectBoard = (option) => {
        this.setState({ selectedBoard: option, errorMessage: "" }, () => {
            this.setSectionDropdownItems()
            this.validateButtonPayload()
        })
    }

    onSelectClass = (option) => {
        let className = option
        let chapterDropdownItems = []

        let masterData = this.masterDataHash[className]
        if (masterData) {
            masterData.chapters.forEach(chapter => {
                chapterDropdownItems.push({ title: chapter.title, value: chapter.key })
                this.chapterHash[chapter.key] = chapter
            })
        }

        this.setState({ selectedClass: option, masterDataId: masterData?._id, chapterDropdownItems, selectedSection: "", selectedSectionId: "", errorMessage: "", reloadChapterDropdown: true }, () => {
            this.setSectionDropdownItems()
            this.setState({ reloadChapterDropdown: false })
            this.validateButtonPayload()
        })
    }

    setSectionDropdownItems() {
        if (this.state.selectedClass && this.state.selectedBoard) {
            let key = `${this.state.selectedBoard}_${this.state.selectedClass}`
            let sections = this.sectionHash[key] || []
            let sectionDropdownItems = sections.map(item => {
                return {
                    title: item.section,
                    value: item._id
                }
            })

            this.setState({ section: "", sectionId: "", sectionDropdownItems, reloadSectionDropdown: true }, () => {
                this.setState({ reloadSectionDropdown: false })
            })
        }
    }

    onSelectDropdown(option, key, key1) {
        if (key == "selectedChapter") {
            let conceptDropdown = []
            if (option) {
                let chapterDetail = this.chapterHash[option?.value]
                chapterDetail.concepts.forEach(element => {
                    conceptDropdown.push(
                        { title: element.title, value: element.key }
                    )
                })
            }

            this.setState({ [key]: option?.value, conceptDropdown, selectedConcept: "", reloadConceptDropdown: true, errorMessage: "" }, () => {
                this.setState({ reloadConceptDropdown: false },)
                this.validateButtonPayload()
            })
        } else {
            let obj = { [key]: option?.value, errorMessage: "" }

            if (key1) obj[key1] = option?.title
            this.setState(obj, () => {
                this.validateButtonPayload()
            })
        }
    }

    onMultiSelectDropdown(option, key) {
        let values = option.map(item => item.value)
        this.setState({ [key]: values, errorMessage: "" }, () => {
            this.validateButtonPayload()
        })
    }

    handleDateEvent = (event, picker) => {
        this.props.delegate && this.props.delegate.resetErrorMessages && this.props.delegate.resetErrorMessages()
        this.startDate = picker.startDate
        this.setState({ selectedDate: new Date(picker.startDate).toLocaleDateString(), errorMessage: "" }, () => {
            this.validateButtonPayload()
        });
    }

    validatePayload = (payload, showError) => {
        this.setState({ enableButton: false })
        if (!payload.board) {
            showError && this.setState({ errorMessage: "Please Select the Board" })
            return false
        }

        if (!payload.class) {
            showError && this.setState({ errorMessage: "Please Select the Class" })
            return false
        }

        if (!payload.chapterKey) {
            showError && this.setState({ errorMessage: "Please Select the Chapter" })
            return false
        }

        if (!payload.concepts || !payload.concepts.length) {
            showError && this.setState({ errorMessage: "Please Select the Concept" })
            return false
        }

        if (!payload.dueDate) {
            showError && this.setState({ errorMessage: "Please Select the Due Date" })
            return false
        }

        if (!payload.schoolId || !payload.teacherId) {
            showError && this.setState({ errorMessage: "Invalid link you've used" })
            return false
        }

        this.setState({ errorMessage: "", enableButton: true })
        return true

    }


    validateButtonPayload() {
        let payload = {
            board: this.state.selectedBoard,
            class: this.state.selectedClass,
            chapterKey: this.state.selectedChapter,
            concepts: this.state.selectedConcept,
            dueDate: this.startDate ? (new Date(new Date(this.startDate).setHours(23, 59, 59, 999)).toISOString()).slice(0, -1) : '',
            masterDataId: this.state.masterDataId,
            section: this.state.section,
            sectionId: this.state.sectionId,
            teacherId: this.teacherId,
            schoolId: this.schoolId,
        }

        this.validatePayload(payload)
    }

    setSelectedType(type) {
        this.setState({selectedSchoolwork : type})
    }

    render() {

        if (this.state.isCompleted) return <CompletionScreen homeworkDetail={this.state.homeworkDetail} />
        return (
            <>
                {this.state.isLoading && <div ><Loading> </Loading></div>}
                <div className='new-home-work-link'>

                    <div className='row no-gutters'>
                        <div className='col-6'>
                            <img className="cw-logo" alt='cw-logo' src={getImageSource(ImageConstants.LOGO_WHITE)} />
                        </div>
                    </div>

                    <div className="parent-box pt-3">
                        <div className="child-box pb-4">
                            <div className="cw-card custom-card-size p-4">

                                <div className="abs-image">
                                    <img alt="" className='cursor-pointer header-image' src={getImageSource(ImageConstants.HEADER1)} />
                                </div>

                                <div className="header-text text-center">{this.state?.schoolName}</div>
                                <div className="header-text-big text-center pt-2">Assign School Work <img className="logo-icon" alt="" src={getImageSource(ImageConstants.LOGO_ICON)} /></div>

                                <div className="pt-4">

                                    <div className="bw-spaces-input">
                                        <div className='app-input-label'>Board <span className='star'>*</span></div>
                                        <div className="pt-2">
                                            <PillButton key={'board'} value={this.state.selectedBoard} options={this.state.boards} onSelect={this.onSelectBoard} size={'md'} style={{ fontSize: 16, fontWeight: 'bold' }} />
                                        </div>
                                    </div>

                                    <div className="bw-spaces-input">
                                        <div className='app-input-label'>Class <span className='star'>*</span></div>
                                        <div className="pt-2">
                                            <PillButton key={'Class'} value={this.state.selectedClass} options={this.state.classes} onSelect={this.onSelectClass} size={'sm'} width="40px" style={{ fontSize: 16, fontWeight: 'bold' }} />
                                        </div>
                                    </div>

                                    <div className="bw-spaces-input">
                                        <div className='app-input-label'>Section</div>
                                        <div className="pt-2">
                                            {
                                                !this.state.reloadSectionDropdown ?
                                                    <Dropdown
                                                        key="Section"
                                                        placeholder='Select Section'
                                                        options={this.state.sectionDropdownItems}
                                                        onSelect={(option) => this.onSelectDropdown(option, "sectionId", "section")}
                                                        value={this.state.sectionId}
                                                        text={"title"}
                                                        style={{ background: "#F6F7F5" }}
                                                    /> : ""
                                            }
                                        </div>
                                    </div>

                                    <div className="bw-spaces-input">
                                        <div className='app-input-label'>Type Of School Work <span className='star'>*</span></div>
                                        <div className="pt-2 d-flex justify-content-around">
                                            <div className='d-flex align-items-center cursor-pointer' onClick={() => this.setSelectedType('STANDARD_CLASSWORK')}>
                                                <div className='radio-button d-flex justify-content-center align-items-center'>
                                                    {this.state.selectedSchoolwork === 'STANDARD_CLASSWORK' ? <div className='inner-color'></div> : <></>}
                                                </div>
                                                <div className='classwork-text ml-1'>Classwork</div>
                                            </div>
                                            <div className='d-flex align-items-center cursor-pointer' onClick={() => this.setSelectedType('STANDARD')}>
                                                <div className='radio-button d-flex justify-content-center align-items-center'>
                                                {this.state.selectedSchoolwork === 'STANDARD' ? <div className='inner-color'></div> : <></>}
                                                </div>
                                                <div className='classwork-text ml-1'>Homework</div>
                                            </div>
                                        </div>
                                    </div>



                                    <div className="bw-spaces-input">
                                        <div className='app-input-label'>Chapter <span className='star'>*</span></div>
                                        <div className="pt-2">
                                            {
                                                !this.state.reloadChapterDropdown ?
                                                    <Dropdown
                                                        key="Chapter"
                                                        placeholder='Select Chapter'
                                                        options={this.state.chapterDropdownItems}
                                                        onSelect={(option) => this.onSelectDropdown(option, "selectedChapter")}
                                                        value={this.state.selectedChapter}
                                                        text={"title"}
                                                        style={{ background: "#F6F7F5" }}
                                                    /> : ""
                                            }
                                        </div>
                                    </div>

                                    <div className="bw-spaces-input">
                                        <div className='app-input-label'>Concept <span className='star'>*</span></div>
                                        <div className="pt-2">
                                            {
                                                !this.state.reloadConceptDropdown ?
                                                    <Dropdown
                                                        key="Concept"
                                                        multiSelect
                                                        placeholder='Select Concept'
                                                        options={this.state.conceptDropdown || []}
                                                        onSelect={(option) => this.onMultiSelectDropdown(option, "selectedConcept")}
                                                        value={this.state.selectedConcept}
                                                        text={"title"}
                                                        style={{ background: "#F6F7F5" }}
                                                    /> : ""
                                            }
                                        </div>
                                    </div>


                                    <div className="bw-spaces-input">
                                        <div className='app-input-label'>Due Date <span className='star'>*</span></div>
                                        <div className="pt-2">
                                            <DateRangePicker onHide={this.handleDateEvent} onCancel={() => { }}
                                                autoApply={true}
                                                initialSettings={{ singleDatePicker: true, startDate: this.startDate, minDate: this.startDate ? this.startDate : new Date(), autoUpdateInput: false }}
                                                locale={{
                                                    'format': 'DD/MM/YYYY'
                                                }}

                                            ><input style={{ background: "#F6F7F5" }} className={`cw-input`} placeholder="Select date" value={this.state.selectedDate} ></input>
                                            </DateRangePicker>
                                        </div>
                                    </div>

                                    <div className=" py-4">
                                        {this.state.errorMessage ? <div className="py-2 text-center text-danger"><b>{this.state.errorMessage}</b></div> : ""}
                                        <div className="bw-spaces-input text-center">
                                            <span className={` ${this.state.enableButton ? "assign-button" : "assign-button-disabled"}`} onClick={() => this.onClickCreate()}> Assign </span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>);
    }
}

export default NewHomeWork;